import { useQuery } from '@tanstack/react-query';
import { fetchJson } from '../lib/api';

export interface InteractionFilters {
  channel?: string;
  entityType?: string;
  entityId?: string;
  search?: string;
  limit?: number;
  offset?: number;
}

export interface Interaction {
  id: string;
  channel: 'email' | 'phone' | 'meeting' | 'note' | 'other';
  direction?: 'inbound' | 'outbound';
  subject?: string;
  body?: string;
  preview?: string;
  fromAddress?: string;
  toAddress?: string;
  participants?: string[];
  entityType?: string;
  entityId?: string;
  entityName?: string;
  contactId?: string;
  contactName?: string;
  tags?: string[];
  createdAt: string;
}

export interface InteractionsResponse {
  interactions: Interaction[];
  total: number;
  limit: number;
  offset: number;
}

function buildQueryString(filters?: InteractionFilters): string {
  if (!filters) return '';
  const params = new URLSearchParams();
  if (filters.channel) params.set('channel', filters.channel);
  if (filters.entityType) params.set('entityType', filters.entityType);
  if (filters.entityId) params.set('entityId', filters.entityId);
  if (filters.search) params.set('search', filters.search);
  if (filters.limit) params.set('limit', String(filters.limit));
  if (filters.offset) params.set('offset', String(filters.offset));
  const qs = params.toString();
  return qs ? `?${qs}` : '';
}

export function useInteractions(filters?: InteractionFilters) {
  return useQuery({
    queryKey: ['interactions', filters],
    queryFn: () =>
      fetchJson<InteractionsResponse>(`/api/interactions${buildQueryString(filters)}`),
  });
}

export function useInteraction(id: string | null) {
  return useQuery({
    queryKey: ['interaction', id],
    queryFn: () => fetchJson<Interaction>(`/api/interactions/${id}`),
    enabled: !!id,
  });
}
